export default __webpack_public_path__ + "static/media/CHULPS_LOGO_ANIMATION_nucleotide.2d14287b.gif";